import type { ProjectLicenseType } from "../models/ProjectLicense";
import { isUiModeDeveloper } from "../uiMode";

export type PdfPreviewKind = "plan" | "list";
export type PdfLicensePolicy = { preview: boolean; purchaseUrl: string };
type LicenseSource = {
  readonly hasDocumentationSubscription?: boolean;
  checkLicenses(type: ProjectLicenseType): boolean;
};

export const PDF_LICENSE_PURCHASE_URL = "https://estada.de/shop";
// Session-only test setting; never persisted into project data or real licenses.
let developmentLicensed = false;

/** Supplies the initial state of the developer UI export checkbox. */
export function getPdfDevelopmentLicensed(): boolean {
  return developmentLicensed;
}

/** Outside developer UI mode this setting is ignored, including calls without the export UI. */
export function setPdfDevelopmentLicensed(licensed: boolean): void {
  if (isUiModeDeveloper()) developmentLicensed = licensed;
}

/** Subscriptions include full PDF/Excel exports, even when developer preview simulation is enabled. */
export function readPdfLicensePolicy(license?: LicenseSource): PdfLicensePolicy {
  if (license?.hasDocumentationSubscription) return { preview: false, purchaseUrl: PDF_LICENSE_PURCHASE_URL };
  if (isUiModeDeveloper()) return { preview: !developmentLicensed, purchaseUrl: PDF_LICENSE_PURCHASE_URL };
  let licensed = false;
  try {
    licensed = license?.checkLicenses("Documentation" as ProjectLicenseType) === true;
  } catch (error) {
    console.warn("PDF license check failed; generating preview", error);
  }
  return { preview: !licensed, purchaseUrl: PDF_LICENSE_PURCHASE_URL };
}

/** Counts printed text rows per chapter page, preserving the existing pagination. */
export function previewRowLimit(rowCount: number, pageIndex: number): number {
  return pageIndex === 0 ? Math.ceil(rowCount / 2) : Math.min(rowCount, 2);
}
